import * as React from 'react';

interface Props {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export function FtSwitch(props: Props) {
    return (
        <label style={{display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontSize: 14}}>
            <input
                type="checkbox"
                checked={props.checked}
                onChange={e => props.onChange(e.target.checked)}
                style={{marginRight: 8}}
            />
            {props.label}
        </label>
    );
}